<template>
  <div>
    <div class="page-header clear-filter">
      <div class="container" id="top">
        <div class="row" style="margin-top: 30px;">
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center;">
            <h1
              class="description"
              style="
            font-size: 2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000000;
            "
            >{{$t(`signin_desc1`)}}</h1>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg-12" style="text-align: center;">
            <img v-bind:src="wallets[walletId].img" width="150px" />
          </div>
        </div>
        <div class="row" style="margin-top: 30px;">
          <div class="col-lg-12" style="text-align: center;">
            <n-button
              @click="unlockWallet()"
              class="btn btn-main btn-wide btn-upper btn-lg"
            >{{$t('signin_unlockwallet')}}</n-button>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg-8" style="margin: auto; height: 1px; border: 1px solid #dddddd;"></div>
        </div>
        <div class="row col-lg-8" style="margin-top: 20px; margin: auto;">
            <div v-for="(wallet, index) in wallets" v-bind:key="wallet.name" v-bind:class="{'col': true, 'wallet_active': index == currentWallet, 'wallet_inactive': index != currentWallet}" v-on:click="selectWallet(index)">
              <img v-bind:src="wallet.img" width="80px"/>
              <div
                style="width:100%; height: 60px; position: absolute; bottom:0px; left: 0px; text-align: left; padding-left: 10px;"
              >
              {{$t(`signin_${wallet.name}_desc`)}}
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
import { Popover } from "element-ui";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  methods: {
    unlockWallet: async function() {
        if (this.walletId == 0) {
            let address = await window.metamask.sign("d");            
            if (address != '' && address != null) {
                this.$store.commit('setWallet', {type: 'metamask', address: address});
                this.$router.push('/home');
            }
        }      
    },
    selectWallet: function(idx) {
        console.log('selectWallet - ', idx);
        this.walletId = idx;
    }
  },
  computed: {
      currentWallet() {
          return this.walletId;
      }
  },
  mounted() {},
  data: function() {
    return {
      walletId: 0,
      wallets: [
        {
          name: "metamask",
          img: "/img/wallet/metamask.png"
        },
        {
          name: "dappcom",
          img: "/img/wallet/dappcom.png"
        }
      ]
    };
  }
};
</script>
<style>
.wallet_inactive {
  width: 100px;
  height: 200px;
  background-color: white;
  border: 1px solid black;
  text-align: center;
  padding: 30px 0px;
  margin: 10px;
  min-width: 225px !important;
  max-width: 225px !important;
}
.wallet_active {
  width: 100px;
  height: 200px;
  background-color: white;
  border: 1px solid blue;
  text-align: center;
  padding: 30px 0px;
  margin: 10px;
  min-width: 225px !important;
  max-width: 225px !important;
}
</style>
